<template>
    <div class="question-cluster-page-wrapper">
        <GameInfo class="game-info" />
        <Tabs :tabsConfig="tabsConfig" @tabClick="tabClick">
            <component :is="currentComponentName" />
        </Tabs>
    </div>
</template>

<script>
import Tabs from "@/views/zhiji/bComponents/switchs/Tabs";
import ClusterManage from "./components/clusterManage/ClusterManage";
import OperationLog from "./components/operationLog/OperationLog";
import ConventionalData from "./components/conventionalData/ConventionalData";
import GameInfo from "@/views/zhiji/components/gameInfo/GameInfo";

export default {
    name: "QuestionClusterPage",
    components: {
        Tabs,
        ClusterManage,
        OperationLog,
        ConventionalData,
        GameInfo
    },
    data() {
        return {
            currentComponentName: "ClusterManage"
        };
    },
    computed: {
        tabsConfig() {
            return [
                {
                    tabName: this.$t("zhiji.cluster.clusterManage"),
                    contentName: "ClusterManage"
                },
                {
                    tabName: this.$t("zhiji.cluster.closedLoop"),
                    contentName: "ConventionalData"
                },
                {
                    tabName: this.$t("zhiji.cluster.operateLog"),
                    contentName: "OperationLog"
                }
            ];
        }
    },
    methods: {
        tabClick(data) {
            this.currentComponentName = data.componentName;
        }
    }
};
</script>

<style scoped lang="scss">
.question-cluster-page-wrapper {
    background: #f2f7fb;
    height: 100%;
    box-sizing: border-box;
    position: relative;

    .game-info {
        position: absolute;
        right: 55px;
        top: 18px;
        width: 248px;
        z-index: 1;
    }
}
</style>
